import { ReactChild, useEffect } from 'react';

import { DataCard } from '@/lib/v2/components';
import { Flex } from '@/lib/v2/components/Layout/Stack';
import { Text } from '@/lib/v2/components/Text';

import { loadingStatus } from '@/src/presentation/types/enum/importStatus.enum';

export type Description = {
  icon: ReactChild;
  description: string;
};

export type ProgressCardProps = {
  title: string;
  dataCard: Description[];
  info?: {
    descriptionInfo: string;
    href: string;
  };
  setHiddenProgressCard: () => void;
  step: number;
  percentage: number;
  mode: number;
  status: loadingStatus;
};

export const ProgressCard = ({ progressCard }: { progressCard: ProgressCardProps }) => {
  useEffect(() => {
    const length = progressCard.dataCard.length - 1;

    if (progressCard.step === length) {
      progressCard.setHiddenProgressCard();
    }
  }, [progressCard]);

  return (
    <div className="w-full">
      <Flex column withGap gapSize="medium">
        <Text variant="headline">{progressCard.title}</Text>
        {
          <DataCard
            dataList={progressCard.dataCard}
            percentage={progressCard.percentage}
            status={progressCard.status}
            step={progressCard.step}
          />
        }
        <a href={progressCard.info?.href}>{progressCard.info?.descriptionInfo}</a>
      </Flex>
    </div>
  );
};
